module.exports = __webpack_public_path__ + "static/img/role.66161b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/mz/role.png
// module id = jjh9
// module chunks = 7